import request from "@/utils/request";
// 设备列表
const getDeviceList = (params) =>
  request.post("/laiHi/web/qualityTesting/pageQualityTestingDevice", params);
// 删除设备
const deleteDevice = (params) =>
  request.post("/laiHi/web/qualityTesting/deletedQualityTestingDevice", params);
// 修改设备状态
const editDevice = (params) =>
  request.post(
    "/laiHi/web/qualityTesting/modifyQualityTestingDeviceStatus",
    params
  );
// 统计今日所有/所有质检设备数量
const getCountAllQuality = (params) =>
  request.post(
    "/laiHi/web/qualityTesting/countAllQualityTestingDevice",
    params
  );
// 添加质检设备
const addDevice = (params) =>
  request.post("/laiHi/common/qualityTestingDevice", params);
// 质检员列表
const getStaffList = (params) =>
  request.post("/laiHi/web/qualityTesting/pageQualityTesting", params);
// 添加质检员
const addStaff = (params) =>
  request.post("/laiHi/web/qualityTesting/addQualityTesting", params);
// 删除质检员
const getDeleteStaff = (params) =>
  request.post("/laiHi/web/qualityTesting/deletedQualityTesting", params);

// 激活码相关
// 生成设备激活码
const addActivationCode = (params) =>
  request.post(
    "/laiHi/web/deviceActivationCode/createDeviceActivationCode",
    params
  );
// 分页获取设备激活码记录
const getActivationCodeRecord = (params) =>
  request.post(
    "/laiHi/web/deviceActivationCode/pageDeviceActivationCodeRecord",
    params
  );
//分页获取设备激活码
const getPageDeviceActivationCode = (params) =>
  request.post(
    "/laiHi/web/deviceActivationCode/pageDeviceActivationCode",
    params
  );
// 通过设备激活码记录id导出设备激活码pdf
const getActivationCodePdf = (recordId, language) =>
  request.get(
    `/laiHi/web/deviceActivationCode/exportDeviceActivationCodePdf/${recordId}/${language}`,
    {
      responseType: "blob", // 👈 必须加上
    }
  );
// 辅助解绑当前账户激活码
const setUnbindActivationCode = (userId) =>
  request.get(
    `/laiHi/web/deviceActivationCode/helpUnbindDeviceActivationCode/${userId}`
  );
export {
  getStaffList,
  getDeviceList,
  addStaff,
  getDeleteStaff,
  deleteDevice,
  editDevice,
  addDevice,
  getCountAllQuality,
  addActivationCode,
  getActivationCodeRecord,
  getPageDeviceActivationCode,
  getActivationCodePdf,
  setUnbindActivationCode,
};
